import React from 'react'
import utils from './utils'
import parser from '../../../../services/parser.services'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer) {

    const commutative = commutative
    const width = gameContainerWidth
    const height = gameContainerHeight
    let { value_1, value_2, value_3 } = quantities
    let { operation_1,
        operation_2,
        answer_required,
        answer_position } = settings
    const colWidth = width / 11
    const fontSize = colWidth
    const answerPosition = answer_position && answer_position === 'left' ? 'left' : 'right'
    let numbersLayout = null
    if (answerPosition === 'left') {
        numbersLayout = (
            <g>
                {answer_required !== 'value_1' || (answer_required === 'value_1' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 10}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'value_1' ? answer : value_1}</text> :
                    utils.getOperationSign(
                        colWidth * 10,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {value_2 && !isNaN(value_2) ? utils.getOperationSign(
                    colWidth * 8.5,
                    height / 2,
                    fontSize,
                    operation_1 === 'addition' ? 'plus' : 'minus'
                ) : null}

                {answer_required !== 'value_2' || (answer_required === 'value_2' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 7}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'value_2' ? answer : value_2}</text> :
                    utils.getOperationSign(
                        colWidth * 7,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {value_3 && !isNaN(value_3) ? utils.getOperationSign(
                    colWidth * 5.5,
                    height / 2,
                    fontSize,
                    operation_2 === 'addition' ? 'plus' : 'minus'
                ) : null}

                {answer_required !== 'value_3' || (answer_required === 'value_3' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 4}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'value_3' ? answer : value_3}</text> :
                    utils.getOperationSign(
                        colWidth * 4,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {utils.getOperationSign(
                    colWidth * 2.5,
                    height / 2,
                    fontSize,
                    'equal'
                )}

                {answer_required !== 'answer' || (answer_required === 'answer' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'answer' ? answer : getAnswer(quantities, settings)}</text> :
                    utils.getOperationSign(
                        colWidth,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }
            </g>
        )
    } else {
        numbersLayout = (
            <g>
                {answer_required !== 'value_1' || (answer_required === 'value_1' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'value_1' ? answer : value_1}</text> :
                    utils.getOperationSign(
                        colWidth,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {value_2 && !isNaN(value_2) ? utils.getOperationSign(
                    colWidth * 2.5,
                    height / 2,
                    fontSize,
                    operation_1 === 'addition' ? 'plus' : 'minus'
                ) : null}

                {answer_required !== 'value_2' || (answer_required === 'value_2' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 4}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'value_2' ? answer : value_2}</text> :
                    utils.getOperationSign(
                        colWidth * 4,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {value_3 && !isNaN(value_3) ? utils.getOperationSign(
                    colWidth * 5.5,
                    height / 2,
                    fontSize,
                    operation_2 === 'addition' ? 'plus' : 'minus'
                ) : null}

                {answer_required !== 'value_3' || (answer_required === 'value_3' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 7}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'value_3' ? answer : value_3}</text> :
                    utils.getOperationSign(
                        colWidth * 7,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }

                {utils.getOperationSign(
                    colWidth * 8.5,
                    height / 2,
                    fontSize,
                    'equal'
                )}

                {answer_required !== 'answer' || (answer_required === 'answer' && answer !== '?') ? <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={colWidth * 10}
                    y={height / 2}
                    textAnchor="middle"
                >{answer_required === 'answer' ? answer : getAnswer(quantities, settings)}</text> :
                    utils.getOperationSign(
                        colWidth * 10,
                        height / 2,
                        fontSize,
                        'answer'
                    )
                }
            </g>
        )
    }
    return (
        <svg
            height={height}
            width={width}
        >
            {numbersLayout}
        </svg>
    )
}

function getAnswer(quantities, settings) {
    let { value_1, value_2, value_3 } = quantities
    let { operation_1, operation_2 } = settings

    let result = operation_1 === 'addition' ? +value_1 + +value_2 : value_1 - value_2

    return operation_2 === 'addition' ? +result + +value_3 : result - value_3
}

function getValues(value_1, value_2, value_3, answer, settings) {
    /* const operation = operation
    const answerRequired = answer_required || 'answer'
    value_3 = value_3 && !isNaN(value_3) ? +value_3 : 0

    if (show_tens) {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 + value_2 + value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            }
        } else {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 - value_2 - value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            }
        }
    } else {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 + value_2 + value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 + value_2 + value_3]
            }
        } else {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 - value_2 - value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 - value_2 - value_3]
            }
        }
    } */
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numbersThree.utils.js